// pair-selection.js
(function () {
  const state = {};
  const colorInput = (pair) => document.getElementById(`prop-${pair}-color`);
  const facesInput = (pair) => document.getElementById(`prop-${pair}-faces`);

  /* -------------------  FIRST PAIR AUTO COLOR  ------------------- */
  document.addEventListener("DOMContentLoaded", () => {

    // Auto-select default variant: Buy 2 Get 1 FREE
    const defaultVariant = document.querySelector(
      'input[type="radio"][value="Buy 2 Get 1 FREE"]'
    );
    if (defaultVariant && !defaultVariant.checked) {
      defaultVariant.checked = true;
      defaultVariant.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Attach Gift Bag handling after everything loads
    setupGiftBagAdd();
  });

  /* -------------------  EXPANDABLE SECTIONS  ------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    const colorSummary = document.getElementById("color-toggle-summary");
    const colorExpanded = document.getElementById("color-toggle-expanded");
    if (colorSummary && colorExpanded) {
      colorSummary.addEventListener("click", function () {
        const visible = colorExpanded.style.display === "block";
        colorExpanded.style.display = visible ? "none" : "block";
        colorSummary.style.display = visible ? "flex" : "none";
      });
      colorExpanded.addEventListener("click", function () {
        colorExpanded.style.display = "none";
        colorSummary.style.display = "flex";
      });
    }
    document.querySelectorAll(".personalization-info-toggle").forEach((b) => {
      b.addEventListener("click", function () {
        const id = this.getAttribute("data-target");
        const box = document.getElementById(id);
        const visible = box.style.display === "block";
        box.style.display = visible ? "none" : "block";
        this.textContent = visible ? "More Info" : "Hide Info";
      });
    });
  });


  /* -------------------  CUSTOM ADD TO CART LOGIC WITH FILE VALIDATION ------------------- */
  document.addEventListener("DOMContentLoaded", () => {
  const fakeBtn = document.querySelector("#custom-addtocart");
  const realBtn = document.querySelector("button.product-form__submit.button");
  const giftBagCheckbox = document.querySelector("#ps-giftbag-checkbox");

  const GIFT_VARIANT_ID = 50673983914287;

  if (!fakeBtn || !realBtn) return;

  fakeBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    // TeeInBlue actual validation checkbox
    const teeChecked = document.querySelector(".custom_artwork_popup .tee-field--clipart input.tee-checkbox-input:checked");

    console.log("TEE CHECKED INPUT:", teeChecked);

    if (!teeChecked) {
      console.warn("TEE VALIDATION FAILED — SKIPPING GIFT BAG");
      realBtn.click();
      return;
    }

    // If gift bag toggle is checked AND tee is validated
    if (giftBagCheckbox && giftBagCheckbox.checked) {
      try {
        const payload = { id: GIFT_VARIANT_ID, quantity: 1 };

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        if (!res.ok) throw new Error("Gift bag add failed");
        console.log("Gift bag added successfully.");

      } catch (err) {
        console.error("Failed to add gift bag:", err);
      }
    }

    // Now add main product
    realBtn.click();
  });
});



document.querySelector('#custom-addtocart').addEventListener('click', function() {
  const targetNode = document.body;

  const observer = new MutationObserver(() => {
    // Detect the required message element
    const requiredMsg = document.querySelector('.tee-required-message');

    if (requiredMsg) {
      if (!document.querySelector('.custom-required-error')) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'upload-error';
        errorDiv.textContent = 'Error: Some fields are required or invalid data';

        document
          .querySelector('#custom-addtocart')
          .insertAdjacentElement('afterend', errorDiv);
      }

      observer.disconnect(); // Stop observing once message is found
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
});



  /******** Moving Section Location ********/

  document.addEventListener("DOMContentLoaded", function() {
    const flexibleTabsParent = document.querySelector('[data-flexible-tabs]');
    const flexibleTabsSettings = document.querySelector('[data-flexible-tabs] [data-flexible-tabs-settings]');
    const productMediaGallery = document.querySelector('.product__media-wrapper media-gallery');

    if (!flexibleTabsParent || !flexibleTabsSettings || !productMediaGallery) return;

    // Create a placeholder comment node to remember the original position
    const placeholder = document.createComment('flexible-tabs-settings-original-position');
    flexibleTabsSettings.before(placeholder);

    function moveTabs() {
      if (window.innerWidth >= 750) {
        // Move AFTER media-gallery
        productMediaGallery.after(flexibleTabsSettings);
      } else {
        // Move BACK inside [data-flexible-tabs] to its original position
        placeholder.after(flexibleTabsSettings);
      }
    }

    // Initial run
    moveTabs();

    // Listen for resize events
    window.addEventListener('resize', moveTabs);
  });

})();